import * as types from '../types/cart';
import actionCreatorFactory from 'typescript-fsa';
var actionCreator = actionCreatorFactory();
export var requestGetCart = actionCreator(types.REQUEST_GET_CART);
export var requestAddCart = actionCreator(types.REQUEST_ADD_CART);
export var requestDeleteCart = actionCreator(types.REQUEST_DELETE_CART);
export var requestClearCart = actionCreator(types.REQUEST_CLEAR_CART);
export var receiveChangeCart = actionCreator(types.RECEIVE_CHANGE_CART);
export var failureCart = actionCreator(types.FAILURE_CART);